import React from 'react'
import '../../App.css'
import ListGroup from 'react-bootstrap/ListGroup'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Tab from 'react-bootstrap/Tab'
import Accordion from 'react-bootstrap/Accordion'
import { useTranslation } from 'react-i18next';

function Content() {
  const {t} = useTranslation();
  return (
    <div>
      <div className='FAQdiv' style={{height:"800px", marginTop:"150px",textAlign:"-webkit-center"}}>
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1" >
          <Row className='questionRow' style={{position:"relative", placeContent:"center" }}>
          <h1 style={{marginBottom:"2rem", color:"#2783C6"}}>FAQ</h1>
            <Col sm={7}>
              <ListGroup horizontal style={{ textAlignLast: "center"}}>
                <ListGroup.Item action href="#link1" className='itemlist'>
                  <span>{t("faq.list.s1")}</span>
                </ListGroup.Item>
                <ListGroup.Item action href="#link2" className='itemlist'>
                  <span>{t("faq.list.s2")}</span>
                </ListGroup.Item>
                <ListGroup.Item action href="#link3" className='itemlist'>
                  <span>{t("faq.list.s3")}</span>
                </ListGroup.Item>
                <ListGroup.Item action href="#link4" className='itemlist'>
                  <span>{t("faq.list.s4")}</span>
                </ListGroup.Item>
                <ListGroup.Item action href="#link5" className='itemlist'>
                  <span>{t("faq.list.s5")}</span>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Row sm={8} className='answerRow' style={{position:"relative", justifyContent:"center", textAlign:"left"  }}>
              <Tab.Content style={{ width:"59.2%"}}>
                <Tab.Pane eventKey="#link1">
                  <Accordion flush>
                    <Accordion.Item eventKey="0"><Accordion.Header>{t("faq.s1.q1")}</Accordion.Header><Accordion.Body>{t("faq.s1.r1")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="1"><Accordion.Header>{t("faq.s1.q2")}</Accordion.Header><Accordion.Body>{t("faq.s1.r2")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="2"><Accordion.Header>{t("faq.s1.q3")}</Accordion.Header><Accordion.Body>{t("faq.s1.r3")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="3"><Accordion.Header>{t("faq.s1.q4")}</Accordion.Header><Accordion.Body>{t("faq.s1.r4")}</Accordion.Body></Accordion.Item>
                  </Accordion>
                </Tab.Pane>
                <Tab.Pane eventKey="#link2">
                  <Accordion flush>
                    <Accordion.Item eventKey="0"><Accordion.Header>{t("faq.s2.q1")}</Accordion.Header><Accordion.Body>{t("faq.s2.r1")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="1"><Accordion.Header>{t("faq.s2.q2")}</Accordion.Header><Accordion.Body>{t("faq.s2.r2")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="2"><Accordion.Header>{t("faq.s2.q3")}</Accordion.Header><Accordion.Body>{t("faq.s2.r3")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="3"><Accordion.Header>{t("faq.s2.q4")}</Accordion.Header><Accordion.Body>{t("faq.s2.r4")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="4"><Accordion.Header>{t("faq.s2.q5")}</Accordion.Header><Accordion.Body>{t("faq.s2.r5")}</Accordion.Body></Accordion.Item>
                  </Accordion>
                </Tab.Pane>
                <Tab.Pane eventKey="#link3">
                  <Accordion flush>
                    <Accordion.Item eventKey="0"><Accordion.Header>{t("faq.s3.q1")}</Accordion.Header><Accordion.Body>{t("faq.s3.r1")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="1"><Accordion.Header>{t("faq.s3.q2")}</Accordion.Header><Accordion.Body>{t("faq.s3.r2")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="2"><Accordion.Header>{t("faq.s3.q3")}</Accordion.Header><Accordion.Body>{t("faq.s3.r3")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="3"><Accordion.Header>{t("faq.s3.q4")}</Accordion.Header><Accordion.Body>{t("faq.s3.r4")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="4"><Accordion.Header>{t("faq.s3.q5")}</Accordion.Header><Accordion.Body>{t("faq.s3.r5")}</Accordion.Body></Accordion.Item>
                  </Accordion>
                </Tab.Pane>
                <Tab.Pane eventKey="#link4">
                  <Accordion flush>
                    <Accordion.Item eventKey="0"><Accordion.Header>{t("faq.s4.q1")}</Accordion.Header><Accordion.Body>{t("faq.s4.r1")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="1"><Accordion.Header>{t("faq.s4.q2")}</Accordion.Header><Accordion.Body>{t("faq.s4.r2")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="2"><Accordion.Header>{t("faq.s4.q3")}</Accordion.Header><Accordion.Body>{t("faq.s4.r3")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="3"><Accordion.Header>{t("faq.s4.q4")}</Accordion.Header><Accordion.Body>{t("faq.s4.r4")}</Accordion.Body></Accordion.Item>
                  </Accordion>
                </Tab.Pane>
                <Tab.Pane eventKey="#link5">
                  <Accordion flush>
                    <Accordion.Item eventKey="0"><Accordion.Header>{t("faq.s5.q1")}</Accordion.Header><Accordion.Body>{t("faq.s5.r1")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="1"><Accordion.Header>{t("faq.s5.q2")}</Accordion.Header><Accordion.Body>{t("faq.s5.r2")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="2"><Accordion.Header>{t("faq.s5.q3")}</Accordion.Header><Accordion.Body>{t("faq.s5.r3")}</Accordion.Body></Accordion.Item>
                    <Accordion.Item eventKey="4"><Accordion.Header>{t("faq.s3.q5")}</Accordion.Header><Accordion.Body>{t("faq.s3.r5")}</Accordion.Body></Accordion.Item>
                  </Accordion>
                </Tab.Pane>
              </Tab.Content>
            </Row>
          </Row>
        </Tab.Container>
      </div>
    </div>
  )
}

export default Content
